import { useCallback } from 'react'

import { toast } from '@buffer-mono/popcorn'

import { useTypedMutation } from '~publish/hooks/useTypedMutation'

import { DismissAllCommentsByPostIdMutation } from './useDismissAll'
import type { DismissAllCommentsForPost } from './useDismissAll'

export const useDismissAllCommentsForPost = (): DismissAllCommentsForPost => {
  const [dismissAllMutation] = useTypedMutation(
    DismissAllCommentsByPostIdMutation,
    (data) => data.dismissAllCommentsByPostId,
    {
      successTypename: 'DismissAllCommentsSuccess',
      refetchQueries: ['Comments'],
    },
  )

  const dismissAllCommentsForPost = useCallback(
    async (postId: string): Promise<void> => {
      if (!postId) {
        throw new Error('A post id is required')
      }

      const result = await dismissAllMutation({
        variables: {
          input: {
            postId,
          },
        },
      })

      if (result.success && result.data) {
        if (result.data.affectedCommentCount === 0) {
          toast.success("We couldn't find any comment to resolve")
        } else {
          toast.success('All comments on this post were resolved.')
        }
      } else {
        toast.error('An error occurred while resolving the comments')
      }
    },
    [dismissAllMutation],
  )

  return dismissAllCommentsForPost
}
